(() => {
  const targets = [
    { match: 'hrana-izberi', href: '/collections/hrana-za-pse-natural-greatness', label: 'Odpri hrano za pse' },
    { match: 'dodatki-izberi', href: '/collections/prehranski-dodatki-za-psa', label: 'Odpri prehranske dodatke' },
    { match: 'nega-izberi', href: '/collections/nega-psa', label: 'Odpri nego psa' }
  ];

  const initialise = (root = document) => {
    root.querySelectorAll('.multicolumn').forEach((section) => {
      const cards = Array.from(section.querySelectorAll('.multicolumn-list > .multicolumn-list__item'));
      if (cards.length !== 3) return;

      const resolved = cards.map((card) => {
        const image = card.querySelector('.multicolumn-card__image');
        const src = (image?.currentSrc || image?.src || '').toLowerCase();
        return targets.find((target) => src.includes(target.match));
      });
      if (resolved.some((target) => !target)) return;

      section.classList.add('lt-collection-circle-nav');
      cards.forEach((card, index) => {
        const cardBody = card.querySelector('.multicolumn-card');
        if (!cardBody) return;

        let link = cardBody.querySelector(':scope > .lt-collection-circle-nav__link');
        if (!link) {
          link = document.createElement('a');
          link.className = 'lt-collection-circle-nav__link';
          const hiddenLabel = document.createElement('span');
          hiddenLabel.className = 'visually-hidden';
          link.appendChild(hiddenLabel);
          cardBody.appendChild(link);
        }

        const hiddenLabel = link.querySelector('.visually-hidden');
        if (hiddenLabel) hiddenLabel.textContent = resolved[index].label;
        link.href = resolved[index].href;
        link.setAttribute('aria-label', resolved[index].label);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();